(() => {
  if (window.__swatchTooltip) return;
  window.__swatchTooltip = true;

  const SWATCH_SELECTOR = '.linked-swatches__swatch, .color-swatch';
  const EDGE_GAP = 16;

  const position = (swatch) => {
    const tooltip = swatch.querySelector('.linked-swatches__tooltip');
    if (!tooltip) return;

    tooltip.style.setProperty('--swatch-tooltip-shift', '0px');

    const viewportWidth = document.documentElement.clientWidth;
    const { left, right } = tooltip.getBoundingClientRect();
    let shift = 0;

    if (left < EDGE_GAP) {
      shift = EDGE_GAP - left;
    } else if (right > viewportWidth - EDGE_GAP) {
      shift = viewportWidth - EDGE_GAP - right;
    }

    if (shift !== 0) {
      tooltip.style.setProperty('--swatch-tooltip-shift', `${Math.round(shift)}px`);
    }
  };

  document.addEventListener('pointerover', (event) => {
    const swatch = event.target.closest?.(SWATCH_SELECTOR);
    if (swatch) position(swatch);
  });
})();
